import type { Site, Procedure as Procedure, ProceduresResponse, SiteLink } from './entities';

export const getSitesAsync = async (): Promise<Site[]> => {
  const response = await fetch('/api/v1/foretak');
  if (!response.ok) {
    throw new Error('Klarte ikke å hente behandlingssteder');
  }

  return response.json() as Promise<Site[]>;
};

export const getProceduresAsync = async (snomedId: string): Promise<Procedure[]> => {
  const response = await fetch(`/api/v1/prosedyrer?snomedId=${snomedId}`);
  if (!response.ok) {
    throw new Error('Klarte ikke å hente behandlinger for kode: ' + snomedId);
  }

  const data = await (response.json() as Promise<ProceduresResponse>);

  return data.value;
};

export const deduplicateSiteLinks = (acc: SiteLink[], link: SiteLink) => {
  if (!acc.some(existingLink => existingLink.href === link?.href)) {
    acc.push(link);
  }
  return acc;
};
